import { APIURL } from '../../constants';
//import {setRoute} from '../../tools'
import axios from 'axios';
import _ from 'lodash';

export default {
  namespaced: true,
  state: {
    features: {},
    locationLayerGroupVisible: false,
    showLocationDialog: false,
    location: undefined,
    matchingGeometries: [],
    showMatchingGeometriesDialog: false,
    locationsAdded: false,
    showSelectedLocationDialog: false,
    fetching: false,
    newLocation: {
      name: ''
    },
    highLighted: undefined,
    activePopup: undefined,
    movedMarkers: {},
    leafletMarkers: [],
    geofenceEditable: false
  },

  actions: {
    findStart(context, payload) {
      let featuresPlain = [];
      //let updateFeatures = [];
      Object.keys(context.state.features).forEach(latlng => {
        context.state.features[latlng].forEach(f => {
          featuresPlain.push(f);
        });
      });

      /*let movedMarkers = Object.keys(context.state.movedMarkers).map((id) => {
				return id;
			})*/

      let movedMarkers = Object.keys(payload._layers).map(id => {
        return id;
      });

      // check if start checkpoint is moved
      //let breakOuter = false;

      let movedFeatures = movedMarkers.map(mm => {
        return featuresPlain.find(f => {
          return f.leafletid == mm;
        });
      });

      let start = movedFeatures.find(mf => {
        return mf.location.properties.isStart === true;
      });

      if (start) {
        return Promise.resolve(start);
      }

      return Promise.reject();
    },

    setGeofenceEditable(context, payload) {
      context.commit('setGeofenceEditable', payload);
    },

    updateGeofenceRadius(context, payload) {
      let editableFeature = context.rootGetters['routes/editableFeature'];
      if (typeof editableFeature !== 'undefined') {
        let url = `${APIURL}trackinglocations/${editableFeature._id}/geofence`;
        axios
          .patch(url, { geofence: payload })
          //axios.put(APIURL + 'trackinglocations/updateGeofence/' + payload._id, {geofence: payload.properties.geofence})
          .then(() => {
            vm.$emit('routeUpdated');
            context.dispatch('status/updateResources', 'routedata', {
              root: true
            });
          })
          .catch(() => {});
      }
    },

    disableMarkerDelete(context) {
      // TODO: continue from here
      let features = context.state.features;
      let startAndFinish = [];
      Object.keys(features).forEach(latlng => {
        let saf = features[latlng].filter(f => {
          return (
            f.location.properties.isStart === true ||
            f.location.properties.isFinish === true
          );
        });

        startAndFinish = startAndFinish.concat(saf);
      });
      let ids = startAndFinish.map(f => {
        return f.leafletid;
      });
      return Promise.resolve(ids);
    },

    mapMarkersToLeafletMarkers(context, payload) {
      //console.log("before", context.state.features)
      let latlngs = Object.keys(payload).map(latlng => {
        return latlng;
      });
      let features = {};
      latlngs.forEach(latlng => {
        if (typeof features[latlng] == 'undefined') {
          features[latlng] = [];
        }
        payload[latlng].forEach(data => {
          let marker = context.state.features[latlng].find(m => {
            return m.location._id == data.id;
          });

          if (marker) {
            marker.leafletid = data.leafletid;
            features[latlng].push(marker);
          }
        });
      });

      //console.log("after", features)

      context.commit('mapMarkersToLeafletMarkers', features);
    },

    flushMovedMarkers(context) {
      context.commit('flushMovedMarkers');
    },

    updateMovedMarkers(context, payload) {
      let featuresPlain = [];
      let updateFeatures = [];
      Object.keys(context.state.features).forEach(latlng => {
        context.state.features[latlng].forEach(f => {
          featuresPlain.push(f);
        });
      });

      /*let movedMarkers = Object.keys(context.state.movedMarkers).map((id) => {
				return id;
			})*/

      let movedMarkers = Object.keys(payload._layers).map(id => {
        return id;
      });

      movedMarkers.forEach(mm => {
        let feature = featuresPlain.find(f => {
          return f.leafletid == mm;
        });

        if (feature) {
          let newCoordinates = [];
          /*newCoordinates[0] = context.state.movedMarkers[mm].lng;
					newCoordinates[1] = context.state.movedMarkers[mm].lat; */

          newCoordinates[0] = payload._layers[mm]._latlng.lng;
          newCoordinates[1] = payload._layers[mm]._latlng.lat;

          feature.location.newGeometry = {
            type: 'Point',
            coordinates: newCoordinates
          };
          updateFeatures.push(feature);
        }
      });

      if (updateFeatures.length > 0) {
        return axios
          .put(
            `${APIURL}trackinglocations/${context.rootGetters['routes/route']._id}/updatePositions`,
            updateFeatures
          )
          .then(() => {
            context.dispatch('status/updateResources', 'routedata', {
              root: true
            });
            return context.dispatch(
              'lines/updateMovedLines',
              { edited: payload },
              { root: true }
            );
            //context.dispatch('routes/calculateBounds', undefined, {root: true})
          })
          .catch(() => {
            //console.log(err)
            return context.dispatch(
              'lines/updateMovedLines',
              { edited: payload },
              { root: true }
            );
          });
      } else {
        return context.dispatch(
          'lines/updateMovedLines',
          { edited: payload },
          { root: true }
        );
      }
    },

    // keeps track of the moved checkpoint markers

    setMovedMarker(context, payload) {
      let featuresPlain = [];
      Object.keys(context.state.features).forEach(latlng => {
        context.state.features[latlng].forEach(f => {
          featuresPlain.push(f);
        });
      });

      let marker = featuresPlain.find(fp => {
        return fp.leafletid == payload._leaflet_id;
      });

      if (marker) {
        context.commit('setMovedMarker', payload);
      }
    },

    storeBlank(context) {
      let route = context.rootGetters['routes/route'];
      let number = route.features.length + 1;
      let name = route.displayName + ' ' + number;
      //let marker = context.state.newLocation.marker;
      let coordinates = [];

      coordinates[0] = context.state.newLocation.marker._latlng.lng;
      coordinates[1] = context.state.newLocation.marker._latlng.lat;

      let blank = {
        routeId: route._id,
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: coordinates
        },
        properties: {
          geofence: 30,
          name: name,
          subTasks: [],
          description: name
        }
      };

      return axios.post(APIURL + 'trackinglocations', blank);
    },

    setActivePopup(context, payload) {
      let features = [];
      Object.keys(context.state.features).forEach(key => {
        context.state.features[key].forEach(f => {
          features.push(f);
        });
      });

      let feature = features.find(f => {
        return f.location._id == payload;
      });

      if (feature) {
        //context.commit('setActivePopup', feature);
        return Promise.resolve(feature);
      }

      return Promise.reject(undefined);
    },

    features(context, payload) {
      context.dispatch('setFetching', true);
      context.commit('features', {});
      context.commit('setLocationsAdded', false);
      let route = context.rootGetters['routes/index'].find(r => {
        return r._id == payload;
      });

      if (route) {
        context.dispatch('routes/route', route, { root: true });

        //context.dispatch('breadcrumbs/addItem', {text: route.displayName, type: 'location'}, {root: true})
        context.commit('setShowSelectedLocationDialog', true);

        return axios.get(APIURL + 'trackinglocations/findByRoute/' + payload);
      }

      console.log('NOT FOUND', context.rootGetters['routes/index'], payload);

      return Promise.reject('Not found');
    },

    setFetching(context, payload) {
      context.commit('setFetching', payload);
    },

    setNewLocationMarker(context, payload) {
      context.commit('setNewLocationMarker', payload);
    },

    storeStart(context, payload) {
      let start = {
        routeId: payload._id,
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: payload.focusPoint.coordinates
        },
        properties: {
          name: payload.displayName,
          isStart: true,
          subTasks: [],
          description: '',
          geofence: 60
        }
      };

      //context.dispatch('store', start);
      let storePromise = context.dispatch('store', start);

      return storePromise;
    },

    storeFinish(context, payload) {
      let finish = {
        routeId: payload._id,
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: payload.focusPoint.coordinates
        },
        properties: {
          name: payload.displayName,
          isFinish: true,
          disabled: true,
          geofence: 50,
          subTasks: [
            {
              type: 10,
              question: {
                content: ''
              }
            }
          ],
          description: ''
        }
      };

      let storePromise = context.dispatch('store', finish);

      return storePromise;
    },

    // TODO: continue from here
    /*setMarkerLeafletId(context, payload)
		{
			context.commit('setMarkerLeafletId', payload)
			//console.log(payload)
		},*/

    store(context, payload) {
      return axios.post(APIURL + 'trackinglocations', {
        properties: payload.properties,
        geometry: payload.geometry
      });
      /*.then((res) => {

				context.dispatch('routes/addLocation', 
					{
						routeId: payload.routeId, 
						location: res.data,
						lang: window.localStorage.getItem('lang')
					}, 
					{root:true}
				);
			})
			.catch((err) => {
				console.log("err", err)
			}); */
    },

    setLocation(context, payload) {
      context.commit('setLocation', payload);
    },

    setLocationLayerGroupVisible(context, payload) {
      context.commit('setLocationLayerGroupVisible', payload);
    },

    setShowSelectedLocationDialog(context, payload) {
      if (!payload) {
        context.dispatch('breadcrumbs/flushItems', undefined, { root: true });
      }
      context.commit('setShowSelectedLocationDialog', payload);
    },

    setShowMatchingGeometriesDialog(context, payload) {
      context.commit('setShowMatchingGeometriesDialog', payload);
    },

    setLocationsAdded(context, payload) {
      context.commit('setLocationsAdded', payload);
    },

    bulkDestroy(context, payload) {
      let features = [];
      let markers = [];
      let layerIds = Object.keys(payload._layers);
      Object.keys(context.state.features).forEach(key => {
        features = features.concat(context.state.features[key]);
      });

      layerIds.forEach(lid => {
        markers.push(
          features.find(f => {
            // start cannot be deleted
            return f.leafletid == lid;
          })
        );
      });

      markers = markers.filter(m => {
        return (
          typeof m !== 'undefined' && m.location.properties.isStart !== true
        );
      });

      //console.log("########## markers", markers)

      if (markers.length > 0) {
        /*let hide = markers.filter((m) => {
					return m.location.properties.removed !== false;
				})



				let remove = markers.filter((m) => {
					return m.location.properties.removed === true;
				})*/

        //console.log("########## hide", hide, "###########remove", remove)

        /*return axios.post(APIURL + 'trackinglocations/bulkDestroy', {
					markers: hide,
					//selectedRoute: context.rootGetters['routes/selectedMarker']._id
					selectedRoute: context.rootGetters['routes/route']._id
				}).then((hideResolve) => {
					return axios.post(APIURL + 'trackinglocations/bulkDestroy?hard=1', {
						markers: remove,
						//selectedRoute: context.rootGetters['routes/selectedMarker']._id
						selectedRoute: context.rootGetters['routes/route']._id
					})
				}).catch((hideErr) => {

					//return Promise.reject(hideErr)

					return axios.post(APIURL + 'trackinglocations/bulkDestroy?hard=1', {
						markers: remove,
						//selectedRoute: context.rootGetters['routes/selectedMarker']._id
						selectedRoute: context.rootGetters['routes/route']._id
					})

					console.log("######### hideErr", hideErr.response.message)
				}) */

        return axios.post(`${APIURL}trackinglocations/bulkDestroy?hard=1`, {
          markers,
          selectedRoute: context.rootGetters['routes/route']._id
        });
      } else {
        return Promise.reject('No markers selected');
      }
    },

    /*bulkDestroy(context, payload)
		{
			let features = [];
			let markers = [];
			let layerIds = Object.keys(payload._layers);
			Object.keys(context.state.features).forEach((key) => {
				features = features.concat(context.state.features[key]);
			})

			layerIds.forEach((lid) => {

				markers.push(features.find((f) => {
					// start cannot be deleted
					return f.leafletid == lid 

				}));

			})

			markers = markers.filter((m) => {
				
				return typeof m !== 'undefined' && m.location.properties.isStart !== true
			});

			console.log("########## markers", markers)

			

			if(markers.length > 0)
			{

				let hide = markers.filter((m) => {
					return m.location.properties.removed !== false;
				})



				let remove = markers.filter((m) => {
					return m.location.properties.removed === true;
				}) 

				console.log("########## hide", hide, "###########remove", remove)

				
				
				return axios.post(APIURL + 'trackinglocations/bulkDestroy', {
					markers: hide,
					//selectedRoute: context.rootGetters['routes/selectedMarker']._id
					selectedRoute: context.rootGetters['routes/route']._id
				}).then((hideResolve) => {
					return axios.post(APIURL + 'trackinglocations/bulkDestroy?hard=1', {
						markers: remove,
						//selectedRoute: context.rootGetters['routes/selectedMarker']._id
						selectedRoute: context.rootGetters['routes/route']._id
					})
				}).catch((hideErr) => {

					//return Promise.reject(hideErr)

					return axios.post(APIURL + 'trackinglocations/bulkDestroy?hard=1', {
						markers: remove,
						//selectedRoute: context.rootGetters['routes/selectedMarker']._id
						selectedRoute: context.rootGetters['routes/route']._id
					})

					console.log("######### hideErr", hideErr.response.message)
				}) 

			} else {
				return Promise.reject('No markers selected')
			}
		},*/

    destroy(context, { element, hardDelete }) {
      //console.log("########### destroy", payload)
      //console.log("####### destroy", context.rootGetters['routes/route'])
      let url = APIURL + 'trackinglocations/bulkDestroy';
      if (hardDelete === true) {
        url += '?hard=1';
      }
      //console.log("hep", url)
      return axios.post(url, {
        markers: [
          {
            location: element
          }
        ],
        //selectedRoute: context.rootGetters['routes/selectedMarker']._id
        selectedRoute: context.rootGetters['routes/route']._id
      });
    },

    restore(context, payload) {
      let url = APIURL + 'trackinglocations/' + payload._id + '/restore';
      axios
        .patch(url)
        .then(res => {
          context.commit('routes/flushFeatureEditable', undefined, {
            root: true
          });
          context.commit('routes/setEditedFeature', res.data, { root: true });
          window.vm.$emit('routeUpdated');
        })
        .catch(err => {
          console.log(err);
        });
    }
  },

  mutations: {
    setGeofenceEditable(state, payload) {
      state.geofenceEditable = payload;
    },

    setLeafletMarkers(state, payload) {
      state.leafletMarkers = [];
      state.leafletMarkers = payload;
    },

    mapMarkersToLeafletMarkers(state, payload) {
      state.features = payload;
    },

    flushMovedMarkers(state) {
      state.movedMarkers = {};
    },

    setMovedMarker(state, payload) {
      state.movedMarkers[payload._leaflet_id] = payload._latlng;
    },

    setActivePopup(state, payload) {
      state.activePopup = payload.leafletid;
    },

    features(state, payload) {
      state.features = payload;
    },

    setFetching(state, payload) {
      state.fetching = payload;
    },

    /*setMarkerLeafletId(state, payload)
		{
			let features = state.features;
			state.features = {};
			let feature = features[payload.key][payload.i];
			feature.leafletid = payload.leafletid;
			features[payload.key][payload.i] = feature;
			state.features = features;
			

			
		}, */

    setNewLocationMarker(state, payload) {
      state.newLocation['marker'] = payload;
    },

    setLocation(state, payload) {
      state.location = payload;
    },

    setLocationLayerGroupVisible(state, payload) {
      state.locationLayerGroupVisible = payload;
    },

    setShowSelectedLocationDialog(state, payload) {
      state.showSelectedLocationDialog = payload;
    },

    /*get(state, payload)
		{	
			
			state.location = payload;
		},*/

    /*setShowLocationDialog(state, payload)
		{
			state.showLocationDialog = payload;
		},*/

    matchingGeometries(state, payload) {
      state.matchingGeometries = payload;
    },

    setShowMatchingGeometriesDialog(state, payload) {
      state.showMatchingGeometriesDialog = payload;
    },

    setLocationsAdded(state, payload) {
      state.locationsAdded = payload;
    }
  },

  getters: {
    leafletMarkers(state) {
      return state.leafletMarkers;
    },

    activePopup(state) {
      return state.activePopup;
    },

    features(state) {
      return state.features;
    },

    locationLayerGroupVisible(state) {
      return state.locationLayerGroupVisible;
    },

    location(state) {
      return state.location;
    },

    /*showLocationDialog(state)
		{
			return state.showLocationDialog;
		},*/

    showMatchingGeometriesDialog(state) {
      return state.showMatchingGeometriesDialog;
    },

    /*matchingGeometries(state)
		{
			console.log("matchingGeometries", state.matchingGeometries)
			return state.matchingGeometries;
		}, */

    hasFeatures(state) {
      return !_.isEmpty(state.features);
    },

    locationsAdded(state) {
      return state.locationsAdded;
    },

    showSelectedLocationDialog(state) {
      return state.showSelectedLocationDialog;
    },

    isFetching(state) {
      return state.fetching;
    },

    geofenceEditable(state) {
      return state.geofenceEditable;
    }
  }
};
